/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationByCategory {
    getFixupPrototypeFunction() { return RecommendationByCategory.fixupPrototype; }

    static newInstance(model: Partial<RecommendationByCategory>): RecommendationByCategory {
        let obj = Object.assign(new RecommendationByCategory(), model);
        RecommendationByCategory.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationByCategory>): RecommendationByCategory {
        if (!model) return null;
        return RecommendationByCategory.newInstance(<RecommendationByCategory> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationByCategory) {
        if (!obj) return;

        models.RecommendationByCategory.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationByCategory): boolean {
        Object.setPrototypeOf(obj, RecommendationByCategory.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.resource_counts) {
            models.ResourceCountByCategory.fixupPrototype(this.resource_counts);
        }
    }

    /**
     * Recommendation ID
     */
    id: string;

    /**
     * Policy ID
     */
    policy_id: string;

    /**
     * Policy Name
     */
    policy_name: string;

    /**
     * Name of the policy recommendation
     */
    name: string;

    /**
     * Status
     */
    status: string;

    /**
     * Impact
     */
    impact: string;

    /**
     * Oscar Classification
     */
    classification: string;

    /**
     * Sub classification of the above classification
     */
    sub_classification: string;

    /**
     * Cloud Account ID
     */
    cloud_account_id: string;

    /**
     * Cloud Account Name
     */
    cloud_account_name: string;

    /**
     * Cloud Service Name
     */
    service_name: string;

    /**
     * Tenant Name
     */
    tenant_name: string;

    /**
     * Time of creation
     */
    created_at: string;

    /**
     * Source
     */
    source: string;

    /**
     * Count of the resource that are open
     */
    resource_counts: models.ResourceCountByCategory;

}
